import React, { Suspense, useEffect, useState } from "react";
import * as XLSX from "xlsx";

import logo from './logo.svg';
import './App.css';
import { Menu } from "./modules/menu";
import { Levels } from "./modules/levels";
import { useTranslation } from "react-i18next";

function App() {
  const { i18n, t } = useTranslation();
  const [data, setData] = useState([]);
  const [current, setCurrent] = useState({ main: "plans", sub: "floor" })
  const [iframe, setIframe] = useState(null);
  const [tmpFloorUnit, setFloorUnit] = useState("floor");
  const [currLvl, setCurrLvl] = useState(0);

  const urlParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    urlParams.get('lang') && i18n.changeLanguage(urlParams.get('lang'));
    fetch("./database.xlsx")
      .then((response) => response.arrayBuffer())
      .then((ab) => {
        const workbook = XLSX.read(ab, { type: "array" });

        // Première feuille
        const sheetName = "Rental Unit - PLB";

        const worksheet = workbook.Sheets[sheetName];

        // Convertir en JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        function normalizeKey(key) {
          return key
            .trim() // enlève espaces début/fin
            .toLowerCase() // minuscules
            .replace(/\s+/g, "_") // espaces -> _
            .replace(/[^\w]/g, ""); // enlève caractères spéciaux
        }

        const formattedData = jsonData.map((item) => {
          const newItem = {};

          Object.entries(item).forEach(([key, value]) => {
            const normalizedKey = normalizeKey(key);

            newItem[normalizedKey] = value;
          });

          return newItem;
        });

        const formattedData2 = formattedData.map((item) => ({
          bathrooms: item["nb_of_bathrooms"],
          bedrooms: item["nb_of_bedrooms"],
          size: Math.round(item["square_feet"]),
          unit: item["unit__lot_number"],
          pdfName: item["unit_model"],
          name: item["unit_name"],
          type: item["unit_type"] === "Studio" ? "1.5" : item["unit_type"].toString(),
          floor: item["floor"],
          price: item["price_list_adjusted"],
        }));

        // console.log(formattedData2)
        setData(formattedData2);
      });

    const handleMessage = (event) => {
      const data = event.data;

      if (data.type === "SCENE_CHANGED") {
        setCurrent(el => ({ ...el, sub: data.scene }));
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    if (current.main === "plans") {
      setIframe(null)
    }
  }, [current]);

  function changeVirtualScene(scene) {
    if (iframe) {
      // console.log(scene, iframe)
      iframe.contentWindow.postMessage(
        {
          type: "LOAD_SCENE",
          scene: scene,
        },
        "*"
      );
    }
  }

  return (
    <Suspense fallback={<div />}>
      <div className="absolute bg-[var(--blue)] w-full h-full flex p-4 gap-4 flex-col-reverse sm:flex-row">
        <div className="w-full h-[50%] bottom-0 sm:h-full sm:w-[250px] lg:w-[350px] bg-[var(--blue)] border border-1 border-[var(--gold)] rounded-[15px] overflow-hidden relative">
          <Menu tmpFloorUnit={tmpFloorUnit} setFloorUnit={setFloorUnit} setCurrLvl={setCurrLvl} current={current} setCurrent={setCurrent} changeVirtualScene={changeVirtualScene} />
        </div>
        <div className="flex-1 bg-[var(--white)] border border-1 border-[var(--gold)] h-full rounded-[15px] overflow-hidden">
          {data.length > 0 && <Levels currLvl={currLvl} setCurrLvl={setCurrLvl} tmpFloorUnit={tmpFloorUnit} setIframe={setIframe} current={current} setCurrent={setCurrent} data={data} />}
        </div>
      </div>
    </Suspense>
  );
}

export default App;
